import { useAuth } from "../../context/auth-context";
import {
  type OtcSubtypeFilterValue,
  otcSubtypesParam,
} from "./adminOtcSubtypes";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";
import type {
  AdminOtcTransactionsDataEnvelope,
  AdminOtcTransactionsDataPayload,
} from "./adminTransactionsData";

const DEFAULT_LIMIT = 25;

export type UseAdminOtcTransactionsDataParams = {
  page: number;
  search?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  /** Defaults to all subtypes; the API requires this param for type=otc. */
  otcSubtype?: OtcSubtypeFilterValue;
  enabled?: boolean;
};

/**
 * Paginated OTC rows from GET api/admin/transactions/data
 * (?type=otc&otcSubtypes=otc-deposit|otc-payout).
 */
export function useAdminOtcTransactionsDataQuery(
  params: UseAdminOtcTransactionsDataParams
) {
  const { isAuthenticated } = useAuth();
  const {
    page,
    search,
    startDate,
    endDate,
    limit = DEFAULT_LIMIT,
    otcSubtype,
    enabled: enabledParam = true,
  } = params;

  const otcSubtypes = otcSubtypesParam(otcSubtype);

  return useApiQuery<
    AdminOtcTransactionsDataEnvelope,
    AdminOtcTransactionsDataPayload
  >({
    queryKey: apiQueryKey("admin-transactions-data", {
      type: "otc",
      page,
      limit,
      search: search?.trim() || null,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
      otcSubtypes,
    }),
    url: "api/admin/transactions/data",
    params: {
      type: "otc",
      page,
      limit,
      search: search?.trim() || undefined,
      startDate,
      endDate,
      otcSubtypes,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
